import { graphql } from '@eluve/graphql.tada';

export const markAppointmentAsCompleteMutation = graphql(`
  mutation markAppointmentAsComplete(
    $id: uuid!
    $userCompletedAt: timestamptz!
  ) {
    updateAppointments(
      where: { id: { _eq: $id } }
      _set: { status: COMPLETED, userCompletedAt: $userCompletedAt }
    ) {
      returning {
        __typename
        id
        status
        userCompletedAt
        completedAt
      }
    }
  }
`);

export const updateSegmentEndedAtMutation = graphql(`
  mutation updateSegmentEndedAt(
    $tenantId: uuid!
    $appointmentId: uuid!
    $segmentId: uuid!
    $recordingEndedAt: timestamptz!
  ) {
    updateAppointmentSegmentsByPk(
      pkColumns: {
        tenantId: $tenantId
        appointmentId: $appointmentId
        id: $segmentId
      }
      _set: { recordingEndedAt: $recordingEndedAt }
    ) {
      id
      recordingEndedAt
    }
  }
`);

export const setAppointmentStartedAtMutation = graphql(`
  mutation setAppointmentStartedAt($id: uuid!, $tenantId: uuid!) {
    updateAppointments(
      where: {
        id: { _eq: $id }
        tenantId: { _eq: $tenantId }
        status: { _eq: NOT_STARTED }
      }
      _set: { startedAt: NOW, status: ACTIVE }
    ) {
      returning {
        id
        startedAt
        status
      }
    }
  }
`);

export const appointmentTotalDurationFragment = graphql(`
  fragment appointmentTotalDuration on Appointments @_unmask {
    totalDuration
  }
`);

export const getAppointmentTotalDuration = graphql(
  `
    query getAppointmentTotalDuration($appointmentId: uuid!, $tenantId: uuid!) {
      appointmentsByPk(id: $appointmentId, tenantId: $tenantId) {
        __typename
        id
        ...appointmentTotalDuration
      }
    }
  `,
  [appointmentTotalDurationFragment],
);

/**
 * Live signed-state read for an appointment. Signing is terminal for the
 * recording lifecycle: once the note is signed, the extension must neither
 * (re)record nor (re)complete, otherwise the completion re-fires summarization
 * against a locked note and pages. Consumers run this network-only right before
 * the record / complete action so a note signed on another surface mid-session
 * is still caught. [ENG-5258]
 */
export const getAppointmentNoteSignedState = graphql(`
  query getAppointmentNoteSignedState($appointmentId: uuid!, $tenantId: uuid!) {
    appointmentsByPk(id: $appointmentId, tenantId: $tenantId) {
      __typename
      id
      doctor_interaction {
        __typename
        appointmentId
        noteSignedAt
      }
    }
  }
`);
